module.exports = __webpack_public_path__ + "img/new_unactive_06.6621887d.jpg";